import { gql } from '@apollo/client';

export const ALL_TARIFFS = gql`
  query AllTariffs {
    allTariffs {
      ignoreSummerTimeChanges
      kind
      ranges {
        from
        pricingTier
        timeZoneKind
        to
      }
      wholeHolidaysCheaper
      wholeWeekendCheaper
    }
  }
`;
